import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useLocaleState } from '@merchant-portal/merchant-portal-base'
import { getDefaultVatRate } from '../../../models/countries'
import { OrderModel } from '../../../models/transaction'
import TransactionAddArticleUI from './UI'
import {
  itemSumIncVat,
  itemSumExVat,
  unitPriceInkVat,
  calculateVats,
} from '../shared/transaction-utils'

const TransactionAddArticle = props => {
  const [article, setArticle] = useState(new OrderModel())
  const [isOrderSumValid, setIsOrderSumValid] = useState(true)
  const [isFormValid, setIsFormValid] = useState(false)
  const [newOrderSum, setNewOrderSum] = useState(0)
  const [newOrderVat, setNewOrderVat] = useState(0)

  const { country } = useLocaleState()

  const calculate = useRef(false)

  useEffect(() => {
    setArticle({
      debitedQuantity: '0',
      creditedQuantity: '0',
      reservedQuantity: '0',
      canceledQuantity: '0',
      newQuantity: 0,
      newQuantityValid: true,
      reservedQuantityValid: true,
      costForOneUnitWithVat: '0',
      totalAmountIncVat: '0',
      totalAmountExVat: '0',
      vatRate: getDefaultVatRate(country) * 100,
      vatSum: '0',
    })
  }, [])

  useEffect(() => {
    if (calculate.current) {
      calculate.current = false
      if (article.quantity && article.vatRate && article.unitPriceExVat) {
        const itemSumWithVat = itemSumIncVat(
          article.quantity,
          article.unitPriceExVat,
          article.vatRate / 100,
        )
        const itemVatSum =
          itemSumIncVat(
            article.quantity,
            article.unitPriceExVat,
            article.vatRate / 100,
          ) - itemSumExVat(article.quantity, article.unitPriceExVat)

        const orderVat = calculateVats(props.cartItems, itemVatSum)
        const valid = props.orderLimit >= itemSumWithVat + props.orderAmount
        let validForm = false
        if (valid && article.description && article.unit) {
          validForm = true
        }

        setArticle({
          ...article,
          costForOneUnitWithVat: unitPriceInkVat(
            article.unitPriceExVat,
            article.vatRate / 100,
          ),
          totalAmountIncVat: itemSumIncVat(
            article.quantity,
            article.unitPriceExVat,
            article.vatRate / 100,
          ),
          totalAmountExVat: itemSumExVat(
            article.quantity,
            article.unitPriceExVat,
          ),
        })

        setIsOrderSumValid(valid)
        setIsFormValid(validForm)
        setNewOrderSum(itemSumWithVat)
        setNewOrderVat(orderVat)
      } else {
        setArticle({
          ...article,
          costForOneUnitWithVat: 0,
          totalAmountIncVat: 0,
          totalAmountExVat: 0,
          vatSum: 0,
        })
        setNewOrderSum(0)
        setNewOrderVat(0)
      }
    }
  }, [article])

  return (
    <div>
      <TransactionAddArticleUI
        isSumValid={isOrderSumValid}
        isFormValid={isFormValid}
        loading={props.loading}
        article={article}
        newOrderSum={newOrderSum}
        newOrderVat={newOrderVat}
        orderLimit={props.orderLimit}
        currentOrderSum={props.orderAmount}
        toggleAddArticle={props.toggleAddArticle}
        handleAdd={item => {
          props.toggleAddArticle(false)
          props.handleAdd(item)
        }}
        handleInputChange={(value, property) => {
          calculate.current = true
          setArticle({
            ...article,
            [property]: value,
          })
        }}
      />
    </div>
  )
}

TransactionAddArticle.propTypes = {
  loading: PropTypes.bool.isRequired,
  orderLimit: PropTypes.any.isRequired,
  handleAdd: PropTypes.func.isRequired,
  cartItems: PropTypes.array.isRequired,
  toggleAddArticle: PropTypes.func.isRequired,
  orderAmount: PropTypes.number.isRequired,
}

export default TransactionAddArticle
